<template>
  <div class="loading" v-if="$store.state.isLoading">
    <van-loading type="spinner" />
  </div>
</template>

<script>
export default {
  name: 'axiosLoading'
};
</script>
<style lang="less" scoped>
.loading{
  background-color: rgba(0, 0, 0, .4);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000000;
}
</style>
